export const PLACEHOLDER_LOCATION_FIELD = "入力してください ";
